/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Populated when a promotion applies to this delivery. Frontend keys off the presence of this object to render the promo badge / crossed-out price.
 * @export
 * @interface DeliveryDtoAppliedPromotion
 */
export interface DeliveryDtoAppliedPromotion {
    /**
     * 
     * @type {number}
     * @memberof DeliveryDtoAppliedPromotion
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof DeliveryDtoAppliedPromotion
     */
    nameEn: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryDtoAppliedPromotion
     */
    nameAr: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryDtoAppliedPromotion
     */
    type: DeliveryDtoAppliedPromotionTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof DeliveryDtoAppliedPromotion
     */
    endsAt: Date | null;
}


/**
 * @export
 */
export const DeliveryDtoAppliedPromotionTypeEnum = {
    DeliveryFeeWaiver: 'DELIVERY_FEE_WAIVER'
} as const;
export type DeliveryDtoAppliedPromotionTypeEnum = typeof DeliveryDtoAppliedPromotionTypeEnum[keyof typeof DeliveryDtoAppliedPromotionTypeEnum];


/**
 * Check if a given object implements the DeliveryDtoAppliedPromotion interface.
 */
export function instanceOfDeliveryDtoAppliedPromotion(value: object): value is DeliveryDtoAppliedPromotion {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('nameEn' in value) || value['nameEn'] === undefined) return false;
    if (!('nameAr' in value) || value['nameAr'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('endsAt' in value) || value['endsAt'] === undefined) return false;
    return true;
}

export function DeliveryDtoAppliedPromotionFromJSON(json: any): DeliveryDtoAppliedPromotion {
    return DeliveryDtoAppliedPromotionFromJSONTyped(json, false);
}

export function DeliveryDtoAppliedPromotionFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeliveryDtoAppliedPromotion {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'nameEn': json['nameEn'],
        'nameAr': json['nameAr'],
        'type': json['type'],
        'endsAt': (json['endsAt'] == null ? null : new Date(json['endsAt'])),
    };
}

export function DeliveryDtoAppliedPromotionToJSON(value?: DeliveryDtoAppliedPromotion | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'nameEn': value['nameEn'],
        'nameAr': value['nameAr'],
        'type': value['type'],
        'endsAt': (value['endsAt'] == null ? null : (value['endsAt'] as any).toISOString()),
    };
}

